/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Segment, Divider, Form, Grid,
  Input, Dimmer, Loader, Button, Dropdown,
  Modal, Icon, Popup, Header
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";

import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

const modeList = [
  {
    key: Constants.DHCP_MODE,
    text: "DHCP",
    value: Constants.DHCP_MODE,
  },
  {
    key: Constants.FIXED_IP_MODE,
    text: Strings.FIXED_IP,
    value: Constants.FIXED_IP_MODE
  }
];

export class OfficeEthernetConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isLoadingConfigDimmerActive: false,
      isConfigDimmerActive: false,
      isUpdateHostnameDimmerActive: false,
      isAlterConfigModalOpen: false,
      updateStatus: Constants.NOT_UPDATING,
      // Hostname
      hostname: "",
      //Ethernet1 config info
      eth1Mode: "",
      eth1Addr: "",
      eth1Netmask: "",
      eth1Gateway: "",
      eth1DNS: "",
      interval: "",
      interval2: "",
      // Ethernet1 status
      oldStatus: "",
      status: ""
    };

    this.updateLoaderRef = React.createRef();
  }

  retrieveData = async () => {
    this.showLoadingConfigDimmer();

    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "configEth1", { mode: "cors"})
        .then(res => res.json())
        .then(data => data)
    );  

    //Hostname
    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "hostname", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );
    
    // Connection status
    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "eth1Status", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      eth1Mode: resolvedPromisses[0].eth1Mode,
      eth1Addr: resolvedPromisses[0].eth1Addr,
      eth1Netmask: resolvedPromisses[0].eth1Netmask,
      eth1Gateway: resolvedPromisses[0].eth1Gateway,
      eth1DNS: resolvedPromisses[0].eth1DNS,
      hostname: resolvedPromisses[1].hostname,
      status: resolvedPromisses[2].status,
      addr: resolvedPromisses[3].addr,
      netmask: resolvedPromisses[3].netmask,
    }, () => {
      this.hideLoadingConfigDimmer();
    });
  }

  // ----------------- Dimmers -----------------
  showConfigDimmer = () => this.setState({ isConfigDimmerActive: true })
  hideConfigDimmer = () => this.setState({ isConfigDimmerActive: false })

  showLoadingConfigDimmer = () => this.setState({ isLoadingConfigDimmerActive: true })
  hideLoadingConfigDimmer = () => this.setState({ isLoadingConfigDimmerActive: false })

  showUpdateHostnameDimmer = () => this.setState({ isUpdateHostnameDimmerActive: true })
  hideUpdateHostnameDimmer = () => this.setState({ isUpdateHostnameDimmerActive: false })

  // ----------------- Form Change -----------------
  handleHostnameChange = (e, { value }) => {
    this.setState({ hostname: value });
  }

  onModeDropdownChange = (e, { value }) => {
    this.setState({ eth1Mode: value });
  }

  handleAddressChange = (e, { value }) => {
    this.setState({ eth1Addr: value });
  }

  handleMaskChange = (e, { value }) => {
    this.setState({ eth1Netmask: value });
  }

  handleGatewayChange = (e, { value }) => {
    this.setState({ eth1Gateway: value });
  }

  handleDNSChange = (e, { value }) => {
    this.setState({ eth1DNS: value });
  }

  // ----------------- Config Modal -----------------
  openAlterConfigModal = () => {
    this.setState({ isAlterConfigModalOpen: true });
  }

  closeAlterConfigModal = () => {
    this.setState({ isAlterConfigModalOpen: false });
  }

  sendHostnameInformation = () => {
    if (!UtilsInstance.validadeHostnameLength(this.state.hostname)) {
      alert(Strings.INVALID_HOSTNAME_1);
    }
    else if (!UtilsInstance.simpleValidadeHostname(this.state.hostname)) {
      alert(Strings.INVALID_HOSTNAME_2);
    }
    else {
      let data = JSON.stringify({
        hostname: this.state.hostname,
      });

      fetch(Constants.REQUEST_IP_ADDRESS + "configHostname_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.handleUpdateCycles();
        })
        .catch((error) => {
          alert(Strings.HOSTNAME_CONFIG_ERROR + "\n" + Strings.REASON_DP + error);
        });
    }
  }

  handleUpdateCycles = () => {
    this.showUpdateHostnameDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_WAITING_2, "");
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.handleAlterConfigurationStatus, 2000) });
  }

  handleAlterConfigurationStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        //console.log("Status atual da tela: ", this.state.updateStatus);
        //console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, "");
            this.hideUpdateHostnameDimmer();
            alert(Strings.HOSTNAME_CONFIG_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  sendEthConfigInformation = async () => {
    if (this.state.eth1Mode === Constants.DHCP_MODE) {
      this.sendDHCPConfigInformation();
    }
    else if (this.state.eth1Mode === Constants.FIXED_IP_MODE) {
      this.sendFixedIpConfigInformation();
    }
  }

  compareStatus = (oldStatus) => {

    let Status = this.state.status;

    if (oldStatus !== Status && Status === Constants.CONNECTED_STATUS && oldStatus !== "") {
      this.retrieveData();
      this.setState({oldStatus: ""});
    }
  }

  updateConnection = () => {
    // Connection status
    const interval = setInterval(() => {
      fetch(Constants.REQUEST_IP_ADDRESS + "eth1Status", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({ status: data.status }));
    }, 30000);

    this.setState({interval: interval});
  }

  sendDHCPConfigInformation = async () => {
    this.closeAlterConfigModal();

    let isDNSEmpty = this.state.eth1DNS === "";
    let isDNSValid = UtilsInstance.validateIPAddress(this.state.eth1DNS);

    if ((!isDNSEmpty && !isDNSValid)) {

      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      if (!isDNSEmpty && !isDNSValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_DNS);
      }

      alert(invalidInformationString);
    }
    else {

      let data = JSON.stringify({
        eth1Mode: this.state.eth1Mode,
        eth1Addr: "",
        eth1Gateway: "",
        eth1Netmask: "",
        eth1DNS: this.state.eth1DNS,
      });

      // Get the old configuration data to compare with the new to see if anything changed
      let previousConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "configEth1", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // If nothing was modified, alert the user and do nothing else
      if (this.state.eth1Mode === previousConfigData.eth1Mode
        && this.state.eth1DNS === previousConfigData.eth1DNS) {
        alert(Strings.CHANGE_AT_LEAST_ONE_OF_THE_FIELDS);
      }
      else {
        this.showConfigDimmer();

        fetch(Constants.REQUEST_IP_ADDRESS + "configEth1_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS);
            this.retrieveData();
          })
          .catch(() => {
            alert(Strings.SEND_CONFIG_FAILURE + "\n" + Strings.REASON_DP + Strings.UPDATE_OFFICE_INTERFACE_CONFIG_ERROR);

            fetch(Constants.REQUEST_IP_ADDRESS + "eth1Status", { mode: "cors" })
              .then(res => res.json())
              .then(data => this.setState({
                status: data.status,
              }));
          })
          .finally(this.hideConfigDimmer);
      }
    }
  }

  sendFixedIpConfigInformation = async () => {
    this.closeAlterConfigModal();

    let cleanedIp = UtilsInstance.removeLeadingZeros(this.state.eth1Addr);
    let cleanedNetmask = UtilsInstance.removeLeadingZeros(this.state.eth1Netmask);
    let cleanedGateway = UtilsInstance.removeLeadingZeros(this.state.eth1Gateway);
    let cleanedDNS = UtilsInstance.removeLeadingZeros(this.state.eth1DNS);

    let isIpValid = UtilsInstance.validateIPAddress(cleanedIp);
    let isZeroIp = UtilsInstance.isZeroIP(cleanedIp);
    let isNetmaskZeroIp = UtilsInstance.isZeroIP(cleanedNetmask);
    let isIpLoopback = UtilsInstance.isIPLoopback(cleanedIp);
    let isBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedIp, cleanedNetmask);
    let isNetworkIp = UtilsInstance.isNetworkAddress(cleanedIp, cleanedNetmask);
    let isSubmaskValid = UtilsInstance.validateSubmask(cleanedNetmask);
    let isGatewayValid = UtilsInstance.validateIPAddress(cleanedGateway);
    let isGatewayBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedGateway, cleanedNetmask);
    let isGatewayNetworkIp = UtilsInstance.isNetworkAddress(cleanedGateway, cleanedNetmask);

    let isDNSEmpty = cleanedDNS === "";
    let isDNSValid = UtilsInstance.validateIPAddress(cleanedDNS);
    let subnetsOverlap = UtilsInstance.subnetsOverlap(
      this.state.addr,
      this.state.netmask,
      cleanedIp,
      cleanedNetmask
    );
    
    if (!isIpValid
      || isZeroIp
      || isNetmaskZeroIp
      || isIpLoopback
      || isBroadcastIp
      || isNetworkIp
      || !isSubmaskValid
      || !isGatewayValid
      || isGatewayBroadcastIp
      || isGatewayNetworkIp
      || (!isDNSEmpty && !isDNSValid)
      || subnetsOverlap) {

      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      if (isIpLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP);
      }
      if (isZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MSG);
      }
      if (isNetmaskZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MASK_MSG);
      }
      if (isBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_IP_MSG);
      }
      if (isNetworkIp && !isZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_IP_MSG);
      }
      if (!isSubmaskValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_SUBMASK);
      }
      if (!isGatewayValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_GATEWAY);
      }
      if (isGatewayBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_GATEWAY_MSG);
      }
      if (isGatewayNetworkIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_GATEWAY_MSG);
      }
      if (!isDNSEmpty && !isDNSValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_DNS);
      }
      if (isIpValid
        && !isIpLoopback
        && !isZeroIp
        && !isNetmaskZeroIp
        && !isBroadcastIp
        && !isNetworkIp
        && isSubmaskValid
        && isGatewayValid
        && !isGatewayBroadcastIp
        && !isGatewayNetworkIp
        && (isDNSEmpty || isDNSValid)
        && subnetsOverlap) {
        invalidInformationString = invalidInformationString.concat(Strings.SUBNET_OVERLAP_OFFICE);
      }
      alert(invalidInformationString);
    }
    else {
      let gtway = "";

      if (cleanedGateway === "") {
        gtway = "0.0.0.0";
      } else {
        gtway = cleanedGateway;
      }

      let data = JSON.stringify({
        eth1Mode: this.state.eth1Mode,
        eth1Addr: cleanedIp,
        eth1Gateway: gtway,
        eth1Netmask: cleanedNetmask,
        eth1DNS: cleanedDNS,
      });

      // Get the old configuration data to compare with the new to see if anything changed
      let previousConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "configEth1", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // If nothing was modified, alert the user and do nothing else
      if (this.state.eth1Mode === previousConfigData.eth1Mode
        && cleanedIp === previousConfigData.eth1Addr
        && gtway === previousConfigData.eth1Gateway
        && cleanedNetmask === previousConfigData.eth1Netmask
        && cleanedDNS === previousConfigData.eth1DNS) {
        alert(Strings.CHANGE_AT_LEAST_ONE_OF_THE_FIELDS);
      }
      // If the IP / gateway / mask was modified, we need to handle the update in another way
      else {
        this.showConfigDimmer();

        fetch(Constants.REQUEST_IP_ADDRESS + "configEth1_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS);
            this.retrieveData();
          })
          .catch(() => {
            alert(Strings.SEND_CONFIG_FAILURE + "\n" + Strings.REASON_DP + Strings.UPDATE_OFFICE_INTERFACE_CONFIG_ERROR);
            fetch(Constants.REQUEST_IP_ADDRESS + "eth1Status", { mode: "cors" })
              .then(res => res.json())
              .then(data => this.setState({
                status: data.status,
              }));
          })
          .finally(this.hideConfigDimmer);
      }
    }
  }

  getStatusText = (status) => {
    if (status === Constants.CONNECTED_STATUS) {
      return (
        <div style={{ height: "50%", display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center" }}>
            <div><Icon name="circle" color="green" /></div>
            <Header size="medium" style={{ margin: 0 }}>
              {Strings.CONNECTED}
            </Header>
          </div>
        </div >
      );
    }
    else if (status === Constants.DISCONNECTED_STATUS) {
      return (
        <div style={{ height: "50%", display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center" }}>
            <div><Icon name="circle" color="red" /></div>
            <Header size="medium" style={{ margin: 0 }}>
              {Strings.DISCONNECTED}
            </Header>
          </div>
        </div>
      );
    }
    else {
      return (
        <p>
          <Icon name="circle" color="grey" />
          {Strings.UNKNOWN}
        </p>
      );
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    this.updateConnection();
    
    const interval = setInterval(() => {
      if (this.state.status === Constants.DISCONNECTED_STATUS) {
        this.setState({oldStatus: this.state.status});
      }
      this.compareStatus(this.state.oldStatus);
    }, 10000);

    this.setState({interval2: interval});
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
    clearInterval(this.state.interval2);
  }

  render() {
    const isLoadingConfigDimmerActive = this.state.isLoadingConfigDimmerActive;
    const isConfigDimmerActive = this.state.isConfigDimmerActive;
    const isUpdateHostnameDimmerActive = this.state.isUpdateHostnameDimmerActive;

    return (
      <React.Fragment>

        <Grid columns={2} doubling stretched style={gridStyle}>
          <Grid.Row>
            <Grid.Column width={10}>
              <Segment style={segmentStyle}>
                <Divider horizontal>
                  {Strings.HOSTNAME}
                  <Popup position='bottom center' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.HOSTNAME_POPUP_1}</p>
                      <p>{Strings.HOSTNAME_POPUP_2}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Form style={formStyle} onSubmit={this.sendHostnameInformation}>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.HOSTNAME}</label>
                    <Input style={inputStyle}
                      placeholder={Strings.HOSTNAME}
                      value={this.state.hostname}
                      onChange={this.handleHostnameChange} />
                  </Form.Field>

                  <Button
                    color="teal"
                    type="submit" >
                    {Strings.SETUP}
                  </Button>
                </Form>

              </Segment>
            </Grid.Column>

            <Grid.Column width={6}>
              <Segment style={segmentStyle}>
                <Divider horizontal>
                  {Strings.CONNECTION_STATUS}
                  <Popup position='bottom center' hoverable pinned wide
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.CONNECTION_STATUS_POPUP_1_1}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>
                {this.getStatusText(this.state.status)}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid columns={1} style={gridStyle}>
          <Grid.Row>
            <Grid.Column>
              <Segment>

                <Divider horizontal>
                  {Strings.INTERFACE_CONFIG}
                  <Popup position='bottom center' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p><b>{Strings.OBS} 1:</b>{Strings.WLAN_CONFIG_POPUP_3}</p>
                      <p>• {Strings.WLAN_CONFIG_POPUP_4}</p>
                      <p>• {Strings.WLAN_CONFIG_POPUP_5}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Form style={formStyle} onSubmit={this.openAlterConfigModal}>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.MODE}</label>
                    <Dropdown
                      placeholder={Strings.DHCP_PLACEHOLDER}
                      style={inputStyle}
                      selection
                      scrolling
                      value={this.state.eth1Mode}
                      options={modeList}
                      onChange={this.onModeDropdownChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.IP}</label>
                    <Input style={inputStyle}
                      disabled={this.state.eth1Mode === Constants.DHCP_MODE}
                      placeholder={Strings.NETWORK_IP_PLACEHOLDER}
                      value={this.state.eth1Addr}
                      onChange={this.handleAddressChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.SUBMASK}</label>
                    <Input style={inputStyle}
                      disabled={this.state.eth1Mode === Constants.DHCP_MODE}
                      placeholder={Strings.NETWORK_MASK_PLACEHOLDER}
                      value={this.state.eth1Netmask}
                      onChange={this.handleMaskChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.GATEWAY}</label>
                    <Input style={inputStyle}
                      disabled={this.state.eth1Mode === Constants.DHCP_MODE}
                      placeholder={Strings.NETWORK_GATEWAY_PLACEHOLDER}
                      value={this.state.eth1Gateway}
                      onChange={this.handleGatewayChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.DNS}{Strings.OPTIONAL}</label>
                    <Input style={inputStyle}
                      placeholder={Strings.NETWORK_GATEWAY_PLACEHOLDER}
                      value={this.state.eth1DNS}
                      onChange={this.handleDNSChange} />
                  </Form.Field>

                  <Button
                    color="teal"
                    type="submit" >
                    {Strings.SETUP}
                  </Button>
                </Form>

                <Dimmer active={isConfigDimmerActive} >
                  <Loader>{Strings.SEND_WLAN_CONFIG_WAITING}</Loader>
                </Dimmer>

                <Dimmer active={isLoadingConfigDimmerActive} >
                  <Loader>{Strings.LOADING_WAITING}</Loader>
                </Dimmer>

              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Modal
          style={modalStyle}
          centered
          size='small'
          open={this.state.isAlterConfigModalOpen}>
          <Modal.Header>{Strings.ALTER_OFFICE_INTERFACE_CONFIG_HEADER}</Modal.Header>
          <Modal.Content>
            <p>{Strings.ALTER_OFFICE_INTERFACE_CONFIG}</p>
            <p><b>{Strings.PS} </b>{Strings.ALTER_OFFICE_INTERFACE_CONFIG_2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' inverted onClick={this.closeAlterConfigModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button color='green' inverted onClick={this.sendEthConfigInformation}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateHostnameDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </React.Fragment >
    );
  }
}

const gridStyle = {
  marginLeft: "2vw"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

const segmentStyle = {
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const modalStyle = {
  height: "260px",
  margin: "20vh auto"
};

export default withRouter(OfficeEthernetConfig);
